export default "__VITE_ASSET__BEFrPwX9__"